module.exports = __webpack_public_path__ + "img/xunlei.a70fc5aa.png";